export default __webpack_public_path__ + "static/media/mentions-icon.5b7cda4f.svg";